import { noop } from 'lodash'
import { createStore } from 'zustand'

import { flattenArrayTree } from '@eastcoal/common/utils/array'
import { findTreeMatches } from '@eastcoal/common/utils/array'

import { AreaTreeStore } from './interface'

export const createAreaTreeStore = () =>
  createStore<AreaTreeStore>((set, get) => ({
    data: [],
    error: undefined,
    loading: false,
    reload: noop,
    value: undefined,
    onChange: undefined,
    setValue(value) {
      set({ value, selectedKeys: value ? [`${value.id}`] : [] })
    },
    selectedKeys: [],
    setSelectedKeys(selectedKeys) {
      const { data } = get()
      const values = findTreeMatches(
        data,
        selectedKeys,
        (item, key) => `${item.id}` === key
      )
      const value = values[0]
      set({ selectedKeys, value })
      get().onChange?.(value)
    },
    expandedKeys: [],
    setExpandedKeys(keys) {
      set({ expandedKeys: keys })
    },
    isExpanded() {
      return get().expandedKeys.length > 0
    },
    toggleExpandAll() {
      const { data, isExpanded } = get()
      set({
        expandedKeys: isExpanded()
          ? []
          : flattenArrayTree(data).map(({ id }) => `${id}`)
      })
    }
  }))
